function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { borderBottom, borderRadius } from 'styled-system';
import Box from '../Box';
import Flex from '../Flex';
import ColumnsIcon from '../icons/ColumnsIcon';
import FilterIcon from '../icons/FilterIcon';
import MaximizeIcon from '../icons/MaximizeIcon';
import RestoreSizeIcon from '../icons/RestoreSizeIcon';
import SpreadsheetIcon from '../icons/SpreadsheetIcon';
import LinkButton from '../LinkButton';
import Text from '../Text';
const StyledSpreadsheetHeader = styled(Flex).withConfig({
  displayName: "SpreadsheetHeader__StyledSpreadsheetHeader",
  componentId: "sc-e1sq92-0"
})(["", " ", " border-bottom-left-radius:0;border-bottom-right-radius:0;"], borderBottom, borderRadius);
const HeaderLink = _ref => {
  let {
    label,
    icon: Icon,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(LinkButton, _extends({
    ml: 4,
    color: "darkBlue",
    hoverColor: "primary",
    display: "block"
  }, props), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    mr: 1
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: 1,
    style: {
      display: 'inline'
    }
  }, label)));
};
const SpreadsheetHeader = /*#__PURE__*/React.memo(_ref2 => {
  let {
    onAddFilter,
    onExportCsv,
    onManageColumns,
    onMaximizeSize,
    onRestoreSize,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledSpreadsheetHeader, props, onManageColumns && /*#__PURE__*/React.createElement(HeaderLink, {
    icon: ColumnsIcon,
    label: "Columns"
  }), onAddFilter && /*#__PURE__*/React.createElement(HeaderLink, {
    icon: FilterIcon,
    label: "Add Filter"
  }), onExportCsv && /*#__PURE__*/React.createElement(HeaderLink, {
    icon: SpreadsheetIcon,
    label: "Export CSV"
  }), onMaximizeSize && /*#__PURE__*/React.createElement(HeaderLink, {
    icon: MaximizeIcon,
    label: "Full Screen",
    onClick: onMaximizeSize
  }), onRestoreSize && /*#__PURE__*/React.createElement(HeaderLink, {
    icon: RestoreSizeIcon,
    label: "Exit Full Screen",
    onClick: onRestoreSize
  }));
});
SpreadsheetHeader.propTypes = {
  ...Box.propTypes,
  ...borderBottom.propTypes,
  ...borderRadius.propTypes,
  onAddFilter: PropTypes.func,
  onExportCsv: PropTypes.func,
  onManageColumns: PropTypes.func,
  onMaximizeSize: PropTypes.func,
  onRestoreSize: PropTypes.func
};
SpreadsheetHeader.defaultProps = {
  bg: 'gray.1',
  borderBottom: 'bold',
  borderRadius: 'corner',
  justifyContent: 'flex-end',
  py: 2,
  px: 3
};
SpreadsheetHeader.displayName = 'SpreadsheetHeader';
export default SpreadsheetHeader;